<template>
  <form>
    <thread-header-container v-if="receiver">
      <div>
        <v-avatar v-if="getAvatar(receiver) && !isMobile" size="30px" style="margin-right: 15px">
          <img :src="getAvatar(receiver).link">
        </v-avatar>
        <v-avatar v-else size="30px" style="margin-right: 10px" :color="colors[receiver.name[0]]">
          <span class="white--text">{{ receiver.name | initials }}</span>
        </v-avatar>
        <span>{{ receiver.name }}</span>
      </div>
      <div class="thread-header__subject">
        <!-- <span v-if="!showFormSubject" @click="showFormSubject = true">
          Enter subject
        </span> -->
        <input
          v-model="form.subject"
          :class="{ 'has-error': subjectError }"
          class="thread-header__input"
          placeholder="Enter Subject"
          autofocus
          @keyup="subjectError = false"
        >
      </div>
      <div v-if="!isMobile">
        {{ todayDate }}
      </div>
    </thread-header-container>
    <div class="thread-body">
      <div class="text-area-container">
        <textarea
          v-model="form.message"
          :class="{ 'has-error': messageError }"
          name="message"
          class="thread-body__textarea"
          placeholder="Write your message here..."
          @keyup="messageError = false"
        />
      </div>
      <v-btn class="thread-body__button" @click="createNewThread">
        Send Message
      </v-btn>
    </div>
  </form>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import colors from '../../utils/avatarColors'
import ThreadHeaderContainer from './ThreadHeaderContainer'

export default {
  components: { ThreadHeaderContainer },
  filters: {
    initials: function(value) {
      if (!value) return ''
      value = value.split(' ')
      let response = ''
      for (const v of value) {
        response = response + v.charAt(0).toUpperCase()
      }
      return response
    }
  },
  props: {
    receiver: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors,
      value: '',
      showFormSubject: false,
      form: {
        subject: '',
        message: ''
      },
      messageError: false,
      subjectError: false
    }
  },
  computed: {
    ...mapState('common', ['isMobile']),
    todayDate() {
      return moment().format('MM-DD-YYYY')
    }
  },
  methods: {
    getAvatar(user) {
      return user && user.media
        ? user.media.find(item => item.type === 'avatar') : undefined
    },
    createNewThread() {
      if (!this.form.message) {
        this.messageError = true
      }

      if (!this.form.subject) {
        this.subjectError = true
      }

      if (this.form.subject && this.form.message) {
        this.$emit('on-message', this.form)
      }
    }
  }
}
</script>

<style lang="sass">
  .thread-header
    &__subject
      flex: 1
      padding: 0 30px
    input
      width: 100%
      padding: 5px 1rem
      border: 1px solid #ececec
      &.has-error
        border-color: $hwayzRed
  .thread-body
    padding: 20px 2rem
    height: calc(100vh - 169px)
    overflow-y: scroll
    background: white
    display: flex
    align-items: flex-end
    flex-direction: column
    .text-area-container
      width: 100%
      textarea
        border: 1px solid $color-grey
        display: block
        width: 100%
        padding: 50px 2rem 30px
        min-height: 120px
        margin: 2rem 2rem 15px 0
        &:focus
          outline: none
        &.has-error
          border-color: $hwayzRed
    &__textarea::placeholder
      color: $completed
    &__button
      margin-right: 0
      background: $hwayzMediumGray !important
      border-radius: 5px !important
  .thread-header__subject span
    text-decoration: underline
    color: $completed
</style>
<style lang="sass" scoped>
.thread-body__button
  color: $hwayzWhite !important
  font-weight: 500 !important
</style>
